// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QcSi","left":"styles_left__1Br0b","desktopActions":"styles_desktopActions__1lih8","title":"styles_title__3oAuY"};